import { Validation, ValidationState, ValidatorType } from '@vp/upload-and-print-validator';

const restrictedValidatorTypes: readonly string[] = [
  ValidatorType.EncryptedValidator,
  ValidatorType.PasswordValidator,
] as const;

/**
 * Filter to ignore
 * PasswordValidator and EncryptedValidator
 * Validation
 */
export const filterValidationToDisplay = (validations: Validation[]): Validation[] => {
  return validations.filter(
    v =>
      !restrictedValidatorTypes.includes(v.id) ||
      v.state === ValidationState.Error ||
      v.state === ValidationState.Warning
  );
};
